import React, { FC } from 'react';

export interface SvgCaretProps {
  className?: string;
}

const SvgCaret: FC<SvgCaretProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41421 7.41429L5.70711 11.7072L7.12132 10.293L2.82843 6.00008L7.12132 1.70718L5.70711 0.292969L1.41421 4.58586L0 6.00008L1.41421 7.41429Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default SvgCaret;
